<script>
import lazyLoadComponent from '@router/lazyload-component'
import { merchantComputed, authComputed } from '@state/helpers'
const initData = () => {
  return {
    title: '會員等級',
    image: '',
    description: '',
    isEnabled: true,
    bannerImages: [],
    bannerImage: ''
  }
}

const formatToForm = (data) => {
  const { images = [{ path: '', default: 0 }], bannerImages = [{ path: '', default: 0 }], ...resetData } = data
  return {
    ...resetData,
    image: images[0]?.path || '',
    bannerImage: bannerImages[0]?.path || '',
  }
}

export default {
  components: {
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
  },
  props: {

    defaultValue: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      submitData: Object.assign({}, initData(), formatToForm(this.defaultValue)),
      tryingStore: false,
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
    canSetPrice() {
      return this.$can('api', 'setPrice')
    },
    formRules() {
      return {
        title: [
          {
            required: true,
            message: '請輸入選單名稱'
          }
        ],
        description: [
          {
            required: true,
            message: '請輸入會員分級說明'
          }
        ]

      }
    },
    foramttedSubmitData() {
      const { image, bannerImage, ...resetData } = this.submitData
      return {
        ...resetData,
        images: image === '' ? [] : [
          {
            path: image ?? '',
            default: 0
          }
        ],
        bannerImages: bannerImage === '' ? [] : [
          {
            path: bannerImage ?? '',
            default: 0
          }
        ],
      }
    },
  },
  created() {
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    onClickLeave() {
      this.$emit('update')
      this.submitData = Object.assign({}, initData(), formatToForm(this.defaultValue))
    },
    async tryToStore() {
      try {
        await this.validate()
        this.tryingStore = true
        await this.$store.dispatch('merchant/postCosmeticBasicSet', {
          type: 'level',
          payload: this.foramttedSubmitData
        })
        this.$emit('update')
        this.$message({
          type: 'success',
          message: '儲存成功',
        })
      } catch (error) {
        console.error(error.message)
      } finally {
        this.tryingStore = false
      }

    },


  },
}
</script>

<template>
  <div :class="$style.pageContent" style="margin-bottom:80px">
    <el-form ref="form" :model="submitData" :rules="formRules" :validate-on-rule-change="false" label-position="top"
      :class="$style.form" autocomplete="off">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="前台是否顯示會員等級系統" class="d-flex flex-wrap isStyleSwitch mb-3">
            <el-switch v-model="submitData.isEnabled" active-text="是" inactive-text="否" :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>
          <el-divider class="mt-0 mb-2"></el-divider>
        </el-col>
        <el-col :span="24">
          <h4 class="title">選單名稱</h4>
          <el-form-item label="" prop="title" required>
            <el-input v-model="submitData.title" class="bg-white is-border" />
          </el-form-item>
        </el-col>
        <el-col v-if="!$isIpetBooking()" :sm="24" :span="24">
          <el-divider class="mt-0 mb-4"></el-divider>
          <h4 class="title">Banner 圖片</h4>
          <el-form-item prop="images" label="">
            <BaseUpload v-model="submitData.bannerImage" :display-column="true" :width-full="true" suggest-size="1920/248"
              resource="memberLevel" type="custom" is-between />
          </el-form-item>
        </el-col>
        <el-col :sm="24" :span="24">
          <el-divider class="mt-0 mb-4"></el-divider>
          <h4 class="title">圖片簡介及說明</h4>
          <el-form-item prop="images" label="">
            <BaseUpload v-model="submitData.image" dir="/memberLevel" suggest-size="598/352" resource="memberLevel"
              type="custom" is-between />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="會員分級說明" prop="description" required>
            <el-input v-model="submitData.description" type="textarea" :autosize="{ minRows: 10 }"
              class="bg-white is-border" />

          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div :class="$style.footer">
      <el-button class="is-round" @click="onClickLeave">取消編輯</el-button>
      <el-button class="is-round" type="primary" :loading="tryingStore" @click="tryToStore">儲存編輯</el-button>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
@import '@src/design/layout_detail_steps.scss';

.form {
  background: #fff;
  padding: 1.125rem;

  :global {
    .el-input-group__prepend {
      padding-left: 0;
    }

    .title {
      font-weight: 500;
      color: $color-secondary;
    }
  }
}

%img-size {
  width: calc(33.333333% - 10px);
  height: 175px;

  @include max-sm {
    width: calc(100% - 10px);
  }
}

:global {
  :local(.upload) {
    margin: 0 -10px;
    border-top: none !important;

    >div {
      @extend %img-size;
    }

    .image-and-action {
      @extend %img-size;

      &+div {
        @extend %img-size;
      }
    }
  }
}

.form-item--split {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;

  :global {
    .el-radio-group {
      flex-shrink: 0;
      margin-right: 15px;
    }

    .el-input {
      max-width: 150px;
    }
  }
}
</style>
